import { ChangeEvent } from 'react';
import '../../styles/reusable/Input.css';

interface InputProps {
  label: string;
  name: string;
  value: string | number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const Input = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  type = 'text',
  placeholder = '',
  required = false,
  disabled = false,
  className = '',
}: InputProps) => {
  return (
    <div className={`reusable-input-group ${className}`}>
      <label htmlFor={name} className="reusable-input-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className="reusable-input-field"
      />
    </div>
  );
};

export default Input;
